module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/_perform.js
// module id = 354
// module chunks = 0